import FiltersList from './FiltersListContainer';

export default FiltersList;
